export enum EFontWeight {
  LIGHT = '300',
  REGULAR = '400',
  MEDIUM = '500',
  BOLD = '700',
  HEAVY = '800',
}
